import { domainsService } from '@/services/domains.service';
import { EnvoiDocument } from '@/types/envoi.types';
import { useQuery } from '@tanstack/react-query';

export const envoisKeys = {
  dossier: (folderUuid: string) => ['envois', 'dossier', folderUuid] as const,
};

/**
 * Les documents envoyés par courriel pour un dossier.
 *
 * Un seul appel pour tout l'onglet : les envois sont ensuite rangés sous
 * l'exécution qui les a produits, sans requête supplémentaire par exécution.
 */
export const useEnvoisDocuments = (folderUuid?: string) => {
  return useQuery<EnvoiDocument[]>({
    queryKey: envoisKeys.dossier(folderUuid || ''),
    queryFn: () => domainsService.getFolderEnvois(folderUuid as string),
    enabled: !!folderUuid,
    staleTime: 30 * 1000,
  });
};
